<template>
  <div class="robbing">
    <nav class="robbing-nav">
      <div class="robbing-nav-item" @click="toggleType('ing')">进行中</div>
      <div class="robbing-nav-item" @click="gotoOtherStatus('complete')">已完成</div>
      <div class="robbing-nav-item" @click="gotoOtherStatus('cancel')">已取消</div>
      <div class="robbing-nav-item select">今日数据</div>
    </nav>

    <a :href="href" download>
      <div class="empty-data">
        <div>
          <i class="iconfont icon-xiangqing"></i>
        </div>
        <div>
          <p>下载数据</p>
          <div>请复制本链接到电脑浏览器中打开并点击下载</div>
        </div>
      </div>
    </a>

    <div class="weui-footer">
      <p class="weui-footer__links">
        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
      </p>
      <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import Blob from "../../excel/Blob";
import Export2Excel from "../../excel/Export2Excel.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      year: moment().format("YYYY"),
      href: "",
      tableData: []
    };
  },
  created() {
    let loading = weui.loading("数据加载中", {
      className: "custom-classname"
    });
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        loading.hide(function() {});
        if (response.data.success) {
          let userId = response.data.data._id;
          this.href =
            "http://wx.aixyt.com/api/paotuiOrder/exportExcel/" + userId;
        }
      })
      .catch(error => {
        console.log(error);
        loading.hide(function() {});
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    toggleType(status) {
      this.$router.push("/robbingList/2/" + status + "/" + this.encodeToken);
    },
    gotoOtherStatus(status) {
      this.$router.push(
        "/robbingListCompleteOrCancel/2/" + status + "/" + this.encodeToken
      );
    }
  }
};
</script>

<style scoped>
.robbing {
  font-size: 14px;
}
.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
}
.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.robbing-nav-item:last-child {
  border-right: none;
}
.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}
.item {
  text-align: center;
  border: 1px solid #1aad19;
  margin: 15px;
}
.item + .item {
  margin-top: 10px;
}
.express-company {
  margin-top: 15px;
  font-size: 22px;
  font-weight: bold;
}
.express-count {
  color: orangered;
  font-weight: bold;
}
.img-container {
  margin-top: 10px;
  margin-bottom: 15px;
}
.img {
  width: 200px;
  height: 200px;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.empty-data {
  text-align: center;
  margin-top: 50px;
}
.empty-data div i {
  font-size: 120px;
  color: orangered;
}
.empty-data div p {
  font-size: 30px;
  color: orangered;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/PaotuiOrderForDownload.vue